import PropTypes from 'prop-types';

export const filterCardsOnly = ({ contentType }) => contentType === "featureCard";
export const filterContentOnly = ({ contentType }) => contentType === "featuredContent";
export const filterOutFailedFetches = ({ failedFetch }) => !failedFetch;
export const isAutoFetchedListing = ({ gotFetched, autoFetch, contentId, contentType  }) =>
	contentType === "featureCard"
		&& contentId
		&& autoFetch === "Listing"
		&& gotFetched;

// contentful_transformation_lib.extract_listing_details()
export const fetchedContentProps = {
	slug: PropTypes.string,
	name: PropTypes.string,
	storeName: PropTypes.string,
	description: PropTypes.string,
	image: PropTypes.string,
	avgRating: PropTypes.number,
	reviewCount: PropTypes.number,
	price: PropTypes.number,
	cardFrequency: PropTypes.string,
	currencySymbol: PropTypes.string,
	soldOut: PropTypes.bool,
	badgeImage: PropTypes.string,
	badgeSize: PropTypes.number,
};

export const featuredCardProps = {
	title: PropTypes.string,
	subTitle: PropTypes.string,
	vendor: PropTypes.string,
	image: PropTypes.string,
	link: PropTypes.string,
	description: PropTypes.string,
	accentColor: PropTypes.string,
	cta: PropTypes.string,
	lightTheme: PropTypes.bool,
	contentType: PropTypes.string,
	contentId: PropTypes.string,
	autoFetch: PropTypes.string,
	gotFetched: PropTypes.bool,
	failedFetch: PropTypes.bool,
	fetchedContent: PropTypes.shape(fetchedContentProps),
	// For debug purposes
	shouldSurfaceErrors: PropTypes.bool,
};

export const featuredContentProps = {
	type: PropTypes.number,
	title: PropTypes.string,
	slug: PropTypes.string,
	subtitle: PropTypes.string,
	url: PropTypes.string,
	cta: PropTypes.string,
	backgroundImage: PropTypes.string,
	content: PropTypes.arrayOf(PropTypes.shape(featuredCardProps)),
};
